import { createStyles, Theme } from '@nelnet/unifi-components-react';

const drawerWidth = 240;

const framestyles = ({ palette, transitions, breakpoints }: Theme) =>
  createStyles({
    appBar: {
      transition: transitions.create('width'),
      marginLeft: drawerWidth,
      [breakpoints.up('md')]: {
        width: `calc(100% - ${drawerWidth}px)`,
      },
      '@media print': {
        position: 'absolute',
      },
      '& a:focus': {
        outline: 'none',
        border: '3px solid transparent',
        boxShadow: '0 0 6px 2px currentColor',
        borderRadius: '2px',
        margin: '-3px',
      },
      '& .ang-a': {
        fill: palette.primary.main,
      },
    },
    appBarHome: {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
    appBarShift: {
      [breakpoints.up('md')]: {
        width: `calc(100% - ${drawerWidth}px)`,
      },
    },
    toolBar: {
      [breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
    },
    drawer: {
      backgroundColor: '#fff',
      [breakpoints.up('md')]: {
        width: `${drawerWidth}px`,
        flexShrink: 0,
      },
    },
    navIconHide: {
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
    angular: {
      backgroundColor: '#c3002f',
      color: '#fff',
      '& .ang-a': {
        fill: '#c3002f',
      },
    },
    react: {
      backgroundColor: '#111',
      color: '#61DAFB',
      '& .ang-a': {
        fill: '#111',
      },
    },
    web: {
      backgroundColor: '#D84018',
      color: '#fff',
      '& .ang-a': {
        fill: '#D84018',
      },
    },
  });

export default framestyles;
